import React from 'react';
import Copyright from '../Copyright';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <Copyright />
            {/* <SocialLinks /> */}
        </footer>
    )
}

export default Footer;